import { useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import Modal from "react-modal";
import "./../style/modal.css";
import "./../style/common.css";
import "./../style/pop-up.css";
import "./../style/subteam.css";
import { TextField, MenuItem } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { MdGroups } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import { CiWarning } from "react-icons/ci";
import { Multiselect } from "multiselect-react-dropdown";
import { FaTrash } from "react-icons/fa";
import { IoPersonAddSharp } from "react-icons/io5";
import { Button } from "antd";

const Msubteam = () => {
  const [subteam, setSubTeam] = useState([]);
  const [team, setTeam] = useState([]); //team
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employee, setEmployees] = useState([]); //emp
  const [allEmployees, setAllEmployees] = useState([]); //all employees for leader mapping
  const [filteredSubteam, setFilteredSubteams] = useState([]); // For search functionality
  const [openDropdowns, setOpenDropdowns] = useState({});
  const toggleDropdown = (teamId) => {
    setOpenDropdowns((prev) => ({ ...prev, [teamId]: !prev[teamId] }));
  };
  const [errors, setErrors] = useState({}); //error show state
  const [formData, setFormData] = useState({
    subteam_teammaster_id: "", //FK Team Master
    subteam_employee_ids: [], //FK Employee_Master
  });
  // State to manage delete subteam details
  const [deleteSubTeamName, setDeleteSubTeamName] = useState("");
  const [deleteSubTeamEmp, setDeleteSubTeamEmp] = useState("");
  const [deleteSubTeamId, setDeleteSubTeamId] = useState(null);
  const [showDeleteSubTeamBox, setShowDeleteSubTeamBox] = useState(false);
  const [editMode, setEditMode] = useState(false); // Edit mode flag
  //Group employees under their respective teams
  const groupedTeams = filteredSubteam.reduce((acc, subteam) => {
    if (!acc[subteam.TeamName]) {
      acc[subteam.TeamName] = [];
    }
    acc[subteam.TeamName].push(subteam);
    return acc;
  }, {});

  //featch SubTeam data from the API
  const fetchSubTeams = async () => {
    setLoading(true);
    try {
      // Fetch the teams
      const response = await axios.get(
        "/api/subteams"
      );
      const reversedData = response.data.subteam.reverse(); // Reverse the fetched data
      setSubTeam(reversedData);
      const subteamData = response.data.subteam.map((st) => ({
        SubTeamId: st.subteam_id,
        SubTeamMasterId: st.subteam_teammaster_id,
        SubTeamEmployeeId: st.subteam_employee_id,
      }));
      // Fetch employee data
      const employeeResponse = await axios.get(
        "/api/emp"
      );
      const employeeData = employeeResponse.data.employees.map((emp) => ({
        EmployeeId: emp.employee_id,
        EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`,
        EmployeeProfile: emp.employee_profile
          ? emp.employee_profile
          : "/images/employeeicon.png", // Default profile image if missing
      }));
      // Fetch team data
      const teamResponse = await axios.get(
        "/api/teams"
      );
      const teamData = teamResponse.data.team.map((t) => ({
        TeamId: t.team_id,
        TeamName: t.team_name,
      }));
      // Map subteam data with team and employee details
      const subteamDataWithDetails = subteamData.map((subteam) => {
        // Find the corresponding employee
        const employee = employeeData.find(
          (emp) => emp.EmployeeId === subteam.SubTeamEmployeeId
        );
        // Find the corresponding team
        const teamDetail = teamData.find(
          (team) => team.TeamId === subteam.SubTeamMasterId
        );
        // Return enriched subteam data
        return {
          ...subteam,
          EmployeeName: employee ? employee.EmployeeName : "Unknown Employee",
          EmployeeProfile: employee
            ? employee.EmployeeProfile
            : "/images/employeeicon.png",
          TeamName: teamDetail ? teamDetail.TeamName : "Unknown Team",
        };
      });
      console.log(
        "Subteam Data with Employee Profile ->>",
        subteamDataWithDetails
      );
      // Update state
      setSubTeam(subteamDataWithDetails);
      setFilteredSubteams(subteamDataWithDetails); // Initialize filtered data
    } catch (error) {
      console.error("Error Fetching SubTeam", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchSubTeams();
  }, []);

  /// Fetch employees data from the API
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/emp"
      );
      console.log(response);
      const allEmpData = response.data.employees.map((emp) => ({
        Employee_id: emp.employee_id,
        EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`,
        EmployeeDesignation: emp.employee_type || "Not Assigned",
      }));
      setAllEmployees(allEmpData);

      const employeeData = response.data.employees
        .filter((emp) => emp.employee_role === "E") // Filter only employees with role "E"
        .map((emp) => ({
          Employee_id: emp.employee_id,
          EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`, // Full name
          EmployeeDesignation: emp.employee_type || "Not Assigned", // Add Designation
        }));
      console.log("Filtered employees:", employeeData);
      setEmployees(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);

  //featch Team data from the API
  const fetchTeams = async () => {
    setLoading(true);
    try {
      // Fetch the teams
      const response = await axios.get(
        "/api/teams"
      );
      console.log(response);
      const teamData = response.data.team.map((t) => ({
        TeamId: t.team_id,
        TeamProjectID: t.team_project_id,
        TemEmpId: t.team_employee_id,
        TeamName: t.team_name,
        TeamIsActive: t.team_isactive,
      }));
      setTeam(teamData.reverse());
      console.log("Team Data->>", teamData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchTeams();
  }, []);

  //edit -- add

  //delete
  const handleDelete = async (subteamData) => {
    console.log("Opening Delete Confirmation for:", subteamData); // Debugging log
    setDeleteSubTeamName(subteamData.TeamName);
    setDeleteSubTeamEmp(subteamData.EmployeeName);
    setDeleteSubTeamId(subteamData.SubTeamId);
    setShowDeleteSubTeamBox(true);
  };

  // Confirm delete function
  const confirmDeleteSubTeam = async () => {
    if (!deleteSubTeamId) return;
    try {
      const response = await axios.delete(
        `/api/subteam/delete/${deleteSubTeamId}`
      );
      if (response.status === 200) {
        toast.success("Member deleted successfully!");
        // Remove the deleted subteam from both lists
        const updatedSubTeams = subteam.filter(
          (item) => item.SubTeamId !== deleteSubTeamId
        );
        setSubTeam(updatedSubTeams);
        setFilteredSubteams(updatedSubTeams); // Ensure filtered list is also updated
      }
      setShowDeleteSubTeamBox(false);
    } catch (error) {
      console.error("Error deleting Project Member:", error);
      toast.error("An error occurred while deleting the Project Member.");
      setShowDeleteSubTeamBox(false);
    }
  };

  // Cancel delete function
  const cancelDeleteSubTeam = () => {
    setShowDeleteSubTeamBox(false); // Close the confirmation box
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const openModal = (teamId = null, subteamData = null) => {
    if (subteamData) {
      setFormData({
        subteam_id: subteamData.SubTeamId || "",
        subteam_teammaster_id: subteamData.SubTeamMasterId || "",
        subteam_employee_ids: Array.isArray(subteamData.SubTeamEmployeeId)
          ? subteamData.SubTeamEmployeeId
          : [],
      });
      setEditMode(true);
    } else {
      setFormData({
        subteam_id: "",
        subteam_teammaster_id: teamId || "",
        subteam_employee_ids: [],
      });
      setEditMode(false);
    }
    setIsModalOpen(true);
    setErrors({});
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  //multiselectField
  const handleMultiselectChange = (selectedList) => {
    setFormData((prevData) => ({
      ...prevData,
      subteam_employee_ids: selectedList.map((emp) => emp.Employee_id),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validation function
    const validateForm = () => {
      const newErrors = {};
      if (!formData.subteam_teammaster_id) {
        newErrors.subteam_teammaster_id = "Team name is required.";
      }
      if (
        !formData.subteam_employee_ids ||
        formData.subteam_employee_ids.length === 0
      ) {
        newErrors.subteam_employee_ids = "At least one employee is required.";
      } else {
        const alreadyAdded = [];
        formData.subteam_employee_ids.forEach((empId) => {
          const exists = subteam.find(
            (st) =>
              st.SubTeamMasterId == formData.subteam_teammaster_id &&
              st.SubTeamEmployeeId == empId
          );
          if (exists) {
            alreadyAdded.push(exists.EmployeeName);
          }
        });

        if (alreadyAdded.length > 0) {
          newErrors.subteam_employee_ids = `Already added: ${alreadyAdded.join(", ")}`;
        }
      }
      return newErrors;
    };
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    // Proceed with API request if no errors
    try {
      let url, method, requestData;
      if (editMode) {
        url =
          "/api/add-multiple-subteams";
        method = "POST";
        requestData = {
          subteam_teammaster_id: Number(formData.subteam_teammaster_id),
          subteam_employee_ids: formData.subteam_employee_ids.map(Number),
        };
      } else {
        url =
          "/api/add-multiple-subteams";
        method = "POST";
        requestData = {
          subteam_teammaster_id: Number(formData.subteam_teammaster_id),
          subteam_employee_ids: formData.subteam_employee_ids.map(Number),
        };
      }
      await axios({
        method,
        url,
        data: requestData,
      });
      toast.success(
        editMode
          ? "Project Member updated successfully!"
          : "Project Member added successfully!"
      );
      fetchSubTeams(); // Refresh data
      closeModal();
      setErrors({});
    } catch (error) {
      console.error("Error submitting data:", error.response?.data);
      toast.error(
        error.response?.data?.message ||
        "An error occurred while submitting data."
      );
    }
  };

  return (
    <div>
      <ToastContainer />
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <MdGroups /> Project Members
        </h1>
        {/* <button className="add-button" onClick={() => openModal()}>
          + Add
        </button> */}
      </div>
      {/* Display Trello-Style Cards */}
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <div className="subteam-board">
          {team.map((teamItem) => {
            const teamName = teamItem.TeamName;
            const subteams = groupedTeams[teamName] || []; // Ensure all teams show up, even if empty

            return (
              <div key={teamItem.TeamId} className="subteam-column">
                <div className="subteam-header" style={{ flexDirection: "column", alignItems: "flex-start", gap: "12px", borderBottom: "none", paddingBottom: "0" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                    <h3 className="subteam-column-title">{teamName}</h3>
                    <Button
                      className="add-member-button"
                      onClick={() => openModal(teamItem.TeamId)}
                    >
                      <IoPersonAddSharp />
                    </Button>
                  </div>
                  <div style={{ fontSize: "12px", color: "var(--text-muted)", fontWeight: "500", background: "rgba(255,255,255,0.05)", padding: "6px 10px", borderRadius: "6px", width: "100%", boxSizing: "border-box" }}>
                    Team Leader: <span style={{ color: "#3b82f6", fontWeight: "700" }}>
                      {(() => {
                        const leader = allEmployees.find(emp => emp.Employee_id === teamItem.TemEmpId);
                        return leader ? leader.EmployeeName : "Not Assigned";
                      })()}
                    </span>
                  </div>
                </div>

                <div
                  style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", background: "rgba(255,255,255,0.02)", borderRadius: "8px", marginBottom: "10px", marginTop: "10px", border: "1px solid rgba(255,255,255,0.05)" }}
                  onClick={() => toggleDropdown(teamItem.TeamId)}
                >
                  <span style={{ fontSize: "13px", fontWeight: "600", color: "#cbd5e1" }}>{subteams.length} Members</span>
                  <span style={{ transform: openDropdowns[teamItem.TeamId] ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s ease", fontSize: "10px", color: "#94a3b8" }}>▼</span>
                </div>

                <div className={`dropdown-content-wrapper ${openDropdowns[teamItem.TeamId] ? "open" : ""}`}>
                  <div className="dropdown-content-inner">
                    <div className="subteam-card-container">
                      {subteams.length > 0 ? (
                        subteams.map((subteam) => {
                          const employeeDetails = employee.find(
                            (emp) => emp.Employee_id === subteam.SubTeamEmployeeId
                          );

                          return (
                            <div key={subteam.SubTeamId} className="subteam-card">
                              {/* Employee Image */}
                              <img
                                src={subteam.EmployeeProfile}
                                alt={subteam.EmployeeName}
                                className="subteam-employee-image"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                              <div>
                                {/* Employee Name */}
                                <p className="subteam-employee">
                                  {subteam.EmployeeName}
                                </p>
                                {/* Employee Designation */}
                                <p className="subteam-designation">
                                  {employeeDetails?.EmployeeDesignation ||
                                    "Not Assigned"}
                                </p>
                              </div>
                              {/* Actions */}
                              <div className="subteam-actions">
                                <FaTrash
                                  className="btn-delete"
                                  onClick={() => handleDelete(subteam)}
                                />
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p className="no-members">No Members Assigned</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {showDeleteSubTeamBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete the{" "}
              <span className="subteam-name">
                <strong>{deleteSubTeamEmp}</strong>
              </span>{" "}
              from the subteam <strong>{deleteSubTeamName}</strong>?
            </div>
            <div className="popup-buttons">
              <button className="confirm-button" onClick={confirmDeleteSubTeam}>
                Yes, Delete
              </button>
              <button className="cancel-button" onClick={cancelDeleteSubTeam}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Team Form"
        className="add-team-modal"
        shouldCloseOnOverlayClick={false}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          content: {
            position: "relative",
            inset: "auto",
            width: "450px",
            background: "#1e293b",
            borderRadius: "16px",
            padding: "24px",
            border: "1px solid rgba(255,255,255,0.1)",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
            color: "#fff",
            overflow: "visible",
          },
        }}
      >
        <h2 style={{ margin: "0 0 24px 0", fontSize: "20px", fontWeight: "600", color: "#f8fafc", display: "flex", alignItems: "center", gap: "10px" }}>
          {editMode ? "Edit Project Member" : "Add Project Member"}
        </h2>
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* Team Locked Field */}
          <div>
            <label style={{ display: "block", fontSize: "14px", color: "#94a3b8", marginBottom: "8px" }}>Selected Team</label>
            <div style={{
              display: "flex", alignItems: "center", gap: "10px", padding: "12px 16px",
              background: "rgba(15, 23, 42, 0.5)", borderRadius: "8px", border: "1px solid rgba(255,255,255,0.05)",
              color: "#cbd5e1", fontSize: "15px", fontWeight: "500"
            }}>
              <MdGroups size={20} color="#3b82f6" />
              {team.find((t) => t.TeamId === formData.subteam_teammaster_id)?.TeamName || "Unknown Team"}
            </div>
            {errors.subteam_teammaster_id && <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.subteam_teammaster_id}</p>}
          </div>

          {/* Employee Selection */}
          <div style={{ position: "relative", zIndex: 999 }}>
            <label style={{ display: "block", fontSize: "14px", color: "#94a3b8", marginBottom: "8px" }}>Select Employee(s)</label>
            <Multiselect
              options={employee || []}
              selectedValues={employee?.filter((emp) => formData?.subteam_employee_ids?.includes(emp?.Employee_id)) || []}
              displayValue="EmployeeName"
              onSelect={handleMultiselectChange}
              onRemove={handleMultiselectChange}
              showCheckbox={true}
              placeholder="Search or Select..."
              avoidHighlightFirstOption={true}
              disabled={editMode}
              style={{
                multiselectContainer: { width: "100%", position: "relative" },
                chips: { background: "#3b82f6", color: "#fff", borderRadius: "6px", fontSize: "13px" },
                searchBox: {
                  minHeight: "45px", fontSize: "15px", padding: "8px 12px",
                  border: "1px solid rgba(255,255,255,0.15)", borderRadius: "8px",
                  background: "rgba(255,255,255,0.03)", color: "#f8fafc"
                },
                optionContainer: {
                  fontSize: "14px", background: "#334155", color: "#e2e8f0",
                  border: "1px solid rgba(255,255,255,0.2)", borderRadius: "8px",
                  marginTop: "5px", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.3)",
                  position: "absolute", width: "100%", zIndex: 1000
                },
                option: {
                  backgroundColor: "transparent", color: "#e2e8f0", padding: "10px"
                },
              }}
            />
            {errors.subteam_employee_ids && (
              <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#ef4444", fontSize: "13px", marginTop: "8px", background: "rgba(239, 68, 68, 0.1)", padding: "8px 12px", borderRadius: "6px" }}>
                <CiWarning size={16} />
                {errors.subteam_employee_ids}
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div className="all-button-form">
            <button type="submit">
              {editMode ? "Save" : "Add Member"}
            </button>
            <button
              type="button"
              onClick={closeModal}
              className="btn-cancel"
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default Msubteam;
